"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLunaError = void 0;
const ConstraintViolationError_1 = require("./ConstraintViolationError");
const LunaError_1 = require("./LunaError");
function isLunaError(error) {
    return typeof error.details === 'object' && error.type;
}
function isAjaxError(error) {
    return error.response && error.response.status;
}
function isConstraintViolationError(error) {
    return (isLunaError(error) &&
        error.type === 'javax.validation.ConstraintViolationException' &&
        Array.isArray(error.details.fields));
}
function createLunaError(error) {
    if (isAjaxError(error) && error.response.status >= 400 && error.response.status < 500) {
        if (isLunaError(error.response.data)) {
            if (isConstraintViolationError(error.response.data)) {
                const fields = error.response.data.details.fields.reduce((result, fieldError) => {
                    if (!result[fieldError.path]) {
                        result[fieldError.path] = {
                            message: fieldError.message,
                            details: fieldError.details
                        };
                    }
                    return result;
                }, {});
                return new ConstraintViolationError_1.ConstraintViolationError(fields);
            }
            return new LunaError_1.LunaError(error.response.data.type.replace(/\./g, '-'), error.response.data.details.attributes || error.response.data.details);
        }
    }
    return error;
}
exports.createLunaError = createLunaError;
//# sourceMappingURL=createLunaError.js.map